import * as navigation from 'Navigation';

import AnalysisTemplateFileState from './AnalysisTemplateFileState';

export default class AnalysisTemplateTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Analysis Template',
      closeable: false,
      preferenceKey: navigation.PREFERENCE_KEY_IGNORE,
    };
  }

  getAnalysisTemplateFileState(): AnalysisTemplateFileState {
    return this.get('AnalysisTemplateFileState');
  }
}
